function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.35 36.35a3 3 0 01-2.12-.88l-7.34-7.34 4.24-4.24 5.22 5.21 12.54-12.54 4.24 4.25-14.66 14.66a3 3 0 01-2.12.88z",
  fill: "#3eb883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 61a3 3 0 01-1.88-.66l-25-20A3 3 0 010 38V3a3 3 0 013-3h50a3 3 0 013 3v35a3 3 0 01-1.13 2.35l-25 20A3 3 0 0128 61zM6 36.56l22 17.59 22-17.59V6H6z",
  fill: "#dbe0eb"
})));

function SvgPrevent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.02 61.02"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Ni4wMiA2MS4wMiI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGQ9Ik0yNS4zNSAzNi4zNWEzIDMgMCAwMS0yLjEyLS44OGwtNy4zNC03LjM0IDQuMjQtNC4yNCA1LjIyIDUuMjEgMTIuNTQtMTIuNTQgNC4yNCA0LjI1LTE0LjY2IDE0LjY2YTMgMyAwIDAxLTIuMTIuODh6IiBmaWxsPSIjM2ViODgzIi8+PHBhdGggZD0iTTI4IDYxYTMgMyAwIDAxLTEuODgtLjY2bC0yNS0yMEEzIDMgMCAwMTAgMzhWM2EzIDMgMCAwMTMtM2g1MGEzIDMgMCAwMTMgM3YzNWEzIDMgMCAwMS0xLjEzIDIuMzVsLTI1IDIwQTMgMyAwIDAxMjggNjF6TTYgMzYuNTZsMjIgMTcuNTkgMjItMTcuNTlWNkg2eiIgZmlsbD0iI2RiZTBlYiIvPjwvZz48L2c+PC9zdmc+";
export { SvgPrevent as ReactComponent };